import React, { useEffect, useState } from 'react';
import supabase from '../supabase';

const System = () => {
  const [admins, setAdmins] = useState([]);
  const [newAdmin, setNewAdmin] = useState({ name: '', email: '' });
  const [maintenance, setMaintenance] = useState(false);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await supabase.from('user_details').select('id, full_name, email');
      setAdmins((data || []).map(u => ({ id: u.id, name: u.full_name || u.email, email: u.email })));
      setLogs([]);
    })();
  }, []);

  return (
    <div className="p-6 max-w-3xl mx-auto space-y-8">
      <h1 className="text-2xl font-bold mb-2">System Settings</h1>

      {/* Platform Info */}
      <section className="bg-white rounded shadow p-6 mb-4">
        <h2 className="text-lg font-semibold mb-2">Platform Info</h2>
        <div className="flex flex-col md:flex-row gap-6">
          <div>
            <span className="block text-gray-500 text-sm">Platform Name</span>
            <span className="font-medium text-gray-900">Gold Mart Admin</span>
          </div>
          <div>
            <span className="block text-gray-500 text-sm">Version</span>
            <span className="font-medium text-gray-900">v1.0.0</span>
          </div>
        </div>
      </section>

      {/* Admin Users */}
      <section className="bg-white rounded shadow p-6 mb-4">
        <h2 className="text-lg font-semibold mb-2">Admin Users</h2>
        <ul className="mb-4">
          {admins.map((admin) => (
            <li key={admin.id} className="flex items-center justify-between py-2 border-b last:border-b-0">
              <div>
                <span className="font-medium text-gray-900">{admin.name}</span>
                <span className="ml-2 text-gray-500 text-sm">{admin.email}</span>
              </div>
              <button
                className="text-red-500 hover:underline text-xs"
                onClick={() => setAdmins(admins.filter(a => a.id !== admin.id))}
                disabled={admins.length === 1}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
        <form
          className="flex gap-2 items-end"
          onSubmit={e => {
            e.preventDefault();
            setAdmins([...admins, { id: admins.length + 1, ...newAdmin }]);
            setNewAdmin({ name: '', email: '' });
          }}
        >
          <input
            type="text"
            placeholder="Name"
            value={newAdmin.name}
            onChange={e => setNewAdmin({ ...newAdmin, name: e.target.value })}
            className="px-3 py-2 border rounded"
            required
          />
          <input
            type="email"
            placeholder="Email"
            value={newAdmin.email}
            onChange={e => setNewAdmin({ ...newAdmin, email: e.target.value })}
            className="px-3 py-2 border rounded"
            required
          />
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Add Admin</button>
        </form>
      </section>

      {/* Maintenance Mode */}
      <section className="bg-white rounded shadow p-6 mb-4">
        <h2 className="text-lg font-semibold mb-2">Maintenance Mode</h2>
        <div className="flex items-center gap-4">
          <span className="text-gray-700">{maintenance ? 'Enabled' : 'Disabled'}</span>
          <button
            className={`px-4 py-2 rounded ${maintenance ? 'bg-red-500 text-white' : 'bg-green-500 text-white'} transition-colors`}
            onClick={() => setMaintenance(!maintenance)}
          >
            {maintenance ? 'Disable' : 'Enable'}
          </button>
        </div>
      </section>

      {/* Logs */}
      <section className="bg-white rounded shadow p-6">
        <h2 className="text-lg font-semibold mb-2">System Logs</h2>
        <ul className="max-h-40 overflow-y-auto text-sm text-gray-700 space-y-1">
          {logs.map(log => (
            <li key={log.id} className="flex justify-between border-b last:border-b-0 py-1">
              <span>{log.message}</span>
              <span className="text-gray-400 ml-4">{log.time}</span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default System; 